import * as React from "react";
import moment from "moment";

import QueryBuilderIcon from "@mui/icons-material/QueryBuilder";
import CheckIcon from "@mui/icons-material/Check";

import {dateFormat} from "@/utils/constants";

import "./index.scss";

export default function TargetCard(props) {
	const {element} = props;

	return (
		<div className="target-card-container">
			<div className="target-card-header">
				<div className="top-left">
					{moment(element.targetDate).format(dateFormat)}
				</div>
				<div className="top-right">
					<div className={"cell" + (element.reached ? " on" : " off")}></div>
				</div>
			</div>
			<div className="target-card-info">
				<div className="info-subtitle">{element.playersCategory.name}</div>
				<div className="info-title">{element.description}</div>
			</div>
			<div className="separator"></div>
			<div className="target-card-preview">
				<div className="target-type"></div>
				{!element.reached && (
					<div className="target-stats">
						<div className="single-stat">
							<QueryBuilderIcon />
							<div>
								{moment(element.targetDeadline).year() > 2000
									? moment(element.targetDeadline).format(dateFormat)
									: "---"}
							</div>
						</div>
					</div>
				)}
				{element.reached && (
					<div className="target-stats">
						<div className="single-stat">
							<CheckIcon />
							<div>{moment(element.dateReached).format(dateFormat)}</div>
						</div>
					</div>
				)}
			</div>
		</div>
	);
}
